import { type FC } from "react";
import { useParams } from "react-router-dom";

import { Card } from "@snapchat/snap-design-system";

import noRoleAssigned from "@app-assets/svg/no-role-assigned-logo.svg";

import { BusinessManagerLinkText } from "../../core/components/messages.generated";
import { type AbsoluteRoute, type RouteParams } from "../../core/routes";
import { BUSINESS_MANAGER_URL } from "../../shared/constants";

import {
    DeniedIcon,
    PermissionsCardContent,
    cardCss,
    permissionsCardTitleCss,
} from "./AssetsPermissionDeniedCard.styles";
import { PermissionsDeniedContent, PermissionsDeniedTitle } from "./messages.generated";

export const AssetsPermissionDeniedCard: FC = () => {
    const { orgId } = useParams<RouteParams[AbsoluteRoute.ORG_ASSETS]>();

    return (
        <Card
            title={<PermissionsDeniedTitle />}
            titleBorder={false}
            titleClassName={permissionsCardTitleCss}
            data-testid="no-lens-folders-card"
            className={cardCss}
        >
            <PermissionsCardContent>
                <DeniedIcon data-testid="empty-search-icon" alt="Empty search" src={noRoleAssigned} />
                <div>
                    <PermissionsDeniedContent
                        link={
                            <a href={`${BUSINESS_MANAGER_URL}/${orgId}`} target="_blank" rel="noreferrer">
                                <BusinessManagerLinkText />
                            </a>
                        }
                    />
                </div>
            </PermissionsCardContent>
        </Card>
    );
};
